import { inject, Injectable } from '@angular/core';
import { GeolocConsentModal } from './cmp-modal/geoloc-consent.modal';
import { ModalController } from '@ionic/angular';
import { UserGeolocConsentService } from '../../providers/auth/user-geoloc-consent.service';
import { isToggleConsentGeolocEnabled } from '../../utils/toggle-utils';

@Injectable({
  providedIn: 'root',
})
export class GeolocConsentModalService {
  private readonly modalController = inject(ModalController);
  private readonly userGeolocService = inject(UserGeolocConsentService);

  async displayModalIfNoConsent(userID: string) {
    if (!isToggleConsentGeolocEnabled()) return;
    try {
      const consent = await this.userGeolocService.getGeolocConsent(userID);
      if (consent) return;

      await this.display();
    } catch (e) {
      console.log(e);
    }
  }

  async displayModalWithCurrentConsent(userID: string) {
    try {
      const consent = await this.userGeolocService.getGeolocConsent(userID);

      await this.display(consent?.geolocationChronoAccepted);
    } catch (e) {
      console.log(e);
    }
  }

  private async display(currentConsentChrono?: boolean) {
    const modal = await this.modalController.create({
      component: GeolocConsentModal,
      componentProps: {
        currentConsentChrono: currentConsentChrono,
      },
    });
    await modal.present();
  }
}
